import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { MdLiveTv } from 'react-icons/md'

const EmptyBroadcastList: React.FC = () => {
  const { t } = useTranslation()

  return (
    <StyledWrapper>
      <MdLiveTv size={60} color={'#616568'} />
      <StyledMessage>{t('broadcast_table_no_data')}</StyledMessage>
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 24px;
  height: 290px;
`

const StyledMessage = styled.p`
  color: #616568;
  text-align: center;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%; /* 30px */
`

export default EmptyBroadcastList
